import { createContext, useContext } from 'react';

/** App data the pointer-registered widgets need beyond FormHell's field props. */
export type SchemaFormContextValue = {
    imagePreviewMap: Record<string, string>;
    readOnly: boolean;
};

const SchemaFormContext = createContext<SchemaFormContextValue>({ imagePreviewMap: {}, readOnly: false });

export const SchemaFormContextProvider = SchemaFormContext.Provider;

export const useSchemaFormContext = (): SchemaFormContextValue => useContext(SchemaFormContext);
